import React, { useState, useEffect } from "react";
import { accountService, alertService } from "../../_services";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-responsive-list'
import 'react-responsive-list/assets/index.css'

function LinkVendorForm({ parentUserId, onClose }) {
  const [merchantCode, setMerchantCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!merchantCode) {
      alertService.error("Merchant Code is required");
      return;
    }

    setIsSubmitting(true);
    accountService.linkVendor({ merchantCode, parentUserId })
      .then(() => {
        alertService.success("Vendor linked successfully");
        onClose();
      })
      .catch(error => {
        alertService.error(error);
        setIsSubmitting(false);
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ padding: "20px" }}>
      <div className="form-group">
        <label>Merchant Code</label>
        <input
          type="text"
          className="form-control"
          value={merchantCode}
          onChange={(e) => setMerchantCode(e.target.value)}
          placeholder="Enter Merchant Code"
          required
        />
      </div>
      <div className="form-group" style={{ float: "right", marginTop: "20px" }}>
        <button
          type="button"
          className="btn btn-cancel"
          onClick={onClose}
          style={{ marginRight: "10px" }}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button 
          type="submit" 
          className="btn btn-primary" 
          style={{ paddingLeft: "40px", paddingRight: "40px", minWidth: "180px" }}
          disabled={isSubmitting}
        >
          {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
          Link Vendor
        </button>
      </div>
    </form>
  );
}

function MultiVendor(props) {
  let urlUsr = window.document.location.pathname.split('view/')[1];
  const loggedInUser = accountService.userValue;
  const viewedUser = props.user;
  
  console.log("MultiVendor Component loaded", urlUsr, viewedUser);

  const [linkedVendors, setLinkedVendors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedMerchantCode, setSelectedMerchantCode] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleLinkVendor = () => {
    props.showModalContent(
      <LinkVendorForm parentUserId={urlUsr?urlUsr:loggedInUser.user.sub} onClose={postSuccess} />, 
      'Link New Vendor'
    );
  };
   
  function fetchLinkedVendors() {
    console.log("Fetching linked vendors for user:", urlUsr);
    setIsLoading(true);
    accountService.getLinkedVendors(urlUsr)
      .then((res) => {
        setLinkedVendors(res || []);
        setIsLoading(false);
      })
      .catch(error => {
        console.error("Error fetching linked vendors:", error);
        alertService.error("Failed to load linked vendors");
        setIsLoading(false);
      });
  }

  useEffect(() => {
    fetchLinkedVendors();
  }, []);

  const postSuccess = () => {
    props.showModal(false);
    fetchLinkedVendors();
  }

  const handleDeleteClick = (merchantCode) => {
    setSelectedMerchantCode(merchantCode);
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    unlinkVendor(selectedMerchantCode);
    setShowConfirm(false);
  };

  const unlinkVendor = (merchantCode) => {
    console.log('Unlinking merchant code:', merchantCode);
    accountService.unlinkVendor({ 
      merchantCode, 
      parentUserId: urlUsr || (loggedInUser && loggedInUser.user && loggedInUser.user.sub) 
    })
      .then(() => fetchLinkedVendors())
      .catch((error) => alertService.error(error));
  };

  const showVendorsList = () => {
    if (isLoading) {
      return (
        <div className="no-data-message">
          <span className="spinner-border spinner-border-sm mr-1"></span> Loading...
        </div>
      );
    }

    if (!linkedVendors || linkedVendors.length === 0) {
      return (
        <div className="no-data-message">
          <p>No vendors linked. Link a new vendor to get started.</p>
        </div>
      );
    }

    return (
      <div className={isMobile ? "franchise-table-mobile" : "franchise-table-desktop"}>
        <Table
          cellPadding="5px"
          cellSpacing="3px"
          style={{ width: "100%", marginTop: "10px" }}
        >
          <Thead>
            <Tr>
              <Th style={{ width: "80%" }}>Merchant Code</Th>
              <Th style={{ width: "20%", textAlign: "right" }}>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {linkedVendors.map((code, index) => (
              <Tr key={index}>
                <Td>
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "#505050",
                      fontSize: isMobile ? "14px" : "16px",
                    }}
                  >
                    {code}
                  </span>
                </Td>
                <Td>
                  <div
                    className={`franchise-actions`}
                    style={{ justifyContent: "flex-end" }}
                  >
                    <i style={{color:"red", cursor:"pointer"}} title="Unlink" class="bi bi-trash" onClick={() => handleDeleteClick(code)}></i>
                  </div>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    );
  };

  return (
    <div className="franchise-management-container">
      <div >
        <div className="personal-details-section"> 
          <div className="personal-details-header">
            <h4 className="personal-details-title">
              Vendors Linked
            </h4>
            <button
              onClick={handleLinkVendor}
              className="reset-password-btn"
              style={{
                padding: isMobile ? "6px 12px" : "8px 16px",
                fontSize: isMobile ? "13px" : "14px",
              }}
            >
              <i class="bi bi-plus-square" style={{ marginRight: "6px" }}></i>
              {isMobile ? "Link Vendor" : "Link New Vendor"}
            </button>
          </div>
          
          <div >
            <div className="franchise-list-container">
              {showVendorsList()}
            </div>
          </div>
        </div>
      </div>
      
      {showConfirm && (
        <div className="dialog-overlay">
          <div className="dialog">
            <h3>WARNING!!</h3>
            <p>Are you sure you want to unlink this vendor (Merchant Code: {selectedMerchantCode})?</p>
            <div style={{display:"inline-block"}}>
            <button className="confirm" onClick={handleConfirm}>Yes</button>
            <button className="cancel" onClick={() => setShowConfirm(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
      
      <style jsx="true">{`
        .franchise-management-container {
          margin-bottom: 30px;
          width: 100%;
        }
        
        .franchise-list-container {
          background-color: transparent;
          border-radius: 0;
          box-shadow: none;
          overflow-x: auto;
          padding: 0;
        }
        
        .no-data-message,
        .error-message {
          padding: 20px;
          text-align: center;
          color: #666;
          background: none;
          border-radius: 8px;
          border:none;
        }
        
        .error-message {
          color: #dc2626;
          background: #fef2f2;
          border-color: #fecaca;
        }
        
        .franchise-actions {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          flex-wrap: wrap;
          padding: 12px 0;
        }
        
        .action-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 14px 24px;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-size: 14px;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          min-width: 85px;
          letter-spacing: 0.025em;
          text-decoration: none;
          position: relative;
          overflow: hidden;
          background: #fff;
        }
        
        /* Table styling */
        .franchise-list-container table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          background: #ffffff;
          border-radius: 8px;
          overflow: hidden;
          border: none;
        }
        
        .franchise-list-container thead {
          background: #f8fafc;
          border-bottom: 1px solid #e5e7eb;
        }
        
        .franchise-list-container th {
          padding: 16px 20px;
          text-align: left;
          font-weight: 600;
          color: #374151;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .franchise-list-container td {
          padding: 16px 20px;
          border-bottom: 1px solid #f1f5f9;
          vertical-align: middle;
        }
        
        .franchise-list-container tbody tr:hover {
          background-color: #f8fafc;
        }
        
        .dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        
        .dialog {
          background-color: white;
          padding: 30px;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          text-align: center;
          max-width: 400px;
          width: 90%;
        }
        
        .dialog h3 {
          color: #dc2626;
          margin-top: 0;
        }
        
        .dialog p {
          margin-bottom: 20px;
          color: #4b5563;
        }
        
        .dialog button {
          padding: 10px 20px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          font-weight: 600;
          margin: 0 10px;
        }
        
        .dialog .confirm {
          background-color: #dc2626;
          color: white;
        }
        
        .dialog .cancel {
          background-color: #e5e7eb;
          color: #374151;
        }
      `}</style>
    </div>
  );
}

export { MultiVendor };
